import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import './i18n';

unregisterServiceWorker();
ReactDOM.render(<App />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js